import { MutationTree } from 'vuex';
import { I18nState } from './state';

export enum I18nMutationTypes {
  SET_LOCALE = 'SET_LOCALE',
  SET_FALLBACK_LOCALE = 'SET_FALLBACK_LOCALE',
  SET_MESSAGES = 'SET_MESSAGES',
  SET_LOCALES = 'SET_LOCALES'
}

export const mutations: MutationTree<I18nState> = {
  [I18nMutationTypes.SET_LOCALE]: (state, locale: string) => {
    state.locale = locale;
  },
  [I18nMutationTypes.SET_FALLBACK_LOCALE]: (state, locale: string) => {
    state.fallbackLocale = locale;
  },
  [I18nMutationTypes.SET_MESSAGES]: (state, messages: any) => {
    state.messages = messages;
  }
};
